import React from 'react';
import { ModuleCarousel, ModuleType } from '../index';
import { ContentfulAsset } from '../../Contentful';

type HeroNarrativeCarouselModuleType = ModuleType & {
  id: string;
  title: string;
  headline: string;
  supertext: string;
  image: ContentfulAsset;
  carouselSlides: ModuleType[];
};

type HeroNarrativeCoverType = ModuleType & {
  id: string;
  title: string;
  headline: string;
  supertext: string;
  image: ContentfulAsset;
  textColor: string;
  backgroundColor: string;
};

export const HeroNarrativeCarouselModule = React.forwardRef<
  React.MutableRefObject<ModuleType>,
  HeroNarrativeCarouselModuleType
>(
  (
    {
      id = '',
      title = '',
      headline = '',
      supertext = '',
      image,
      carouselSlides = [],
      textColor = '',
      backgroundColor = '',
      contentType = '',
      isVisible = false,
    },
    _,
  ) => {
    const coverSlide: HeroNarrativeCoverType = {
      id,
      title,
      contentType: 'heroCaseStudyCover',
      headline,
      supertext,
      image,
      textColor,
      backgroundColor,
    };
    const slides = [coverSlide, ...carouselSlides].filter(Boolean);

    return (
      <ModuleCarousel
        isHeader={false}
        carouselSlides={slides}
        contentType={contentType}
        title={title}
        isVisible={isVisible}
      />
    );
  },
);
